module.exports = __webpack_public_path__ + "static/img/empty_search@2x.a7e2f2e4.png";